import { useEffect, useRef } from 'react';
import {
  ReferenceInput,
  ReferenceInputProps,
  SelectInput,
  useGetMany,
  useSimpleFormIteratorItem,
} from 'react-admin';
import { useFormContext, useWatch } from 'react-hook-form';
import { Item } from '../../types';
import { useLocation } from 'react-router-dom';


export const LineTaxInput = (props: Omit<ReferenceInputProps, 'children'>) => {
  const iterator = useSimpleFormIteratorItem();
  const { setValue } = useFormContext();

  const itemId = useWatch<Item>({ name: `lines.${iterator.index}.item` });
  const currentTax = useWatch({ name: `lines.${iterator.index}.tax` });
  const previousItemId = useRef<string>(itemId);
  const location = useLocation();

  const { data: itemData } = useGetMany<Item>(
    'items',
    {
      ids: [itemId],
    },
    {
      enabled: !!itemId,
    }
  );
  useEffect(() => {
    // Set tax when item changes OR when we have a new item but no tax set
    if (previousItemId.current !== itemId || (itemData?.[0]?.SalesTaxCodeRef?.value && !currentTax)) {
      if (
        itemData &&
        itemData[0] &&
        itemData[0].SalesTaxCodeRef &&
        itemData[0].SalesTaxCodeRef.value
      ) {
        setValue(
          `lines.${iterator.index}.tax`,
          itemData[0].SalesTaxCodeRef.value
        );
      } else {
        setValue(`lines.${iterator.index}.tax`, null);
      }
      previousItemId.current = itemId;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId, itemData, currentTax]);

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <ReferenceInput {...props}>
      <SelectInput
        label="resources.contracts.fields.tax"
        optionText={(tax) => tax.Name}
        optionValue="id"
        sx={{
          width: 200,
        }}
      />
    </ReferenceInput>
  );
};
